// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { DescriptionsTokens } from './type';

const descriptionsTokens: DescriptionsTokens = {
  descriptionsTitlePaddingBottom: 'Spacing-12',
  descriptionsLabelPaddingBottom: 'Spacing-12',
  descriptionsLabelPaddingRight: 'Spacing-8',
  descriptionsValuePaddingBottom: 'Spacing-12',
  descriptionsTitleSmallSize: 'Font-14',
  descriptionsTitleDefaultSize: 'Font-16',
  descriptionsTitleLargeSize: 'Font-18',
  descriptionsBorderDefaultSize: 'Border-1',
  descriptionsFontSmallSize: 'Font-12',
  descriptionsFontDefaultSize: 'Font-14',
  descriptionsFontLargeSize: 'Font-16',
  descriptionsLabelColor: 'Neutral-text-4',
  descriptionsValueColor: 'Neutral-text-5',
  descriptionsTitleColor: 'Neutral-text-5',
  descriptionsBackgroundColor: 'Neutral-fill-2',
  descriptionsBorderColor: 'Neutral-border-1',
  descriptionsTitleFontWeight: 'Weight-medium',
  descriptionsTitleGap: 'Size-2',
  descriptionsCellGap: 'Spacing-0',
  descriptionsBorderRadius: 'Radius-lesser',
  descriptionsBorderRightSize: '1px',
  descriptionsBorderBottomSize: '1px',
  descriptionsBorderPaddingX: 'Spacing-12',
  descriptionsBorderPaddingY: 'Spacing-8',
  descriptionsInlineBorderPaddingX: 'Spacing-8',
  descriptionsInlineBorderPaddingY: 'Spacing-12',
  descriptionsVerticalPaddingBottom: 'Spacing-2',
};

export default descriptionsTokens;
